module.exports = __webpack_public_path__ + "img/kakao_mode_example.e348ed10.png";